import { c as _c } from "react/compiler-runtime";
import { IcoLock24 } from '@onefootprint/icons';
import type { Entity, EntityOnboarding } from '@onefootprint/request-types/dashboard';
import { Button } from '@onefootprint/ui';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import type { VaultType } from '@/entities/hooks/use-entity-vault';
import useDecryptOnboarding from '../../../decrypt/use-decrypt-onboarding';
type EncryptedContentProps = {
  canDecrypt: boolean;
  entity: Entity;
  onboarding: EntityOnboarding;
  onDecryptSuccess: (vault: VaultType) => void;
  vaultData: VaultType | undefined;
};
const EncryptedContent = t0 => {
  const $ = _c(30);
  const {
    canDecrypt,
    entity,
    onboarding,
    onDecryptSuccess,
    vaultData
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "onboardings"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  const descriptionId = useId();
  let t2;
  if ($[1] !== entity || $[2] !== onDecryptSuccess || $[3] !== onboarding || $[4] !== vaultData) {
    t2 = {
      entity,
      onboarding,
      onDecryptSuccess,
      vaultData
    };
    $[1] = entity;
    $[2] = onDecryptSuccess;
    $[3] = onboarding;
    $[4] = vaultData;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    decrypt,
    isDecrypting
  } = useDecryptOnboarding(t2);
  const isNotAllowed = Boolean(vaultData) && !canDecrypt;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center justify-center size-12 rounded-full bg-neutral-inverted shadow-[0_0_0_4px_rgba(0,0,0,0.04)]"><IcoLock24 color="neutralInverted" /></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <p className="text-label-2">{t4}</p>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isNotAllowed || $[12] !== t) {
    t6 = isNotAllowed ? t(_temp2) : t(_temp3);
    $[11] = isNotAllowed;
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== descriptionId || $[15] !== t6) {
    t7 = <p id={descriptionId} className="text-body-3 text-tertiary">{t6}</p>;
    $[14] = descriptionId;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="flex flex-col gap-1 max-w-sm">{t5}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== canDecrypt || $[21] !== decrypt || $[22] !== descriptionId || $[23] !== isDecrypting || $[24] !== isNotAllowed || $[25] !== t) {
    t9 = !isNotAllowed && <Button aria-describedby={descriptionId} disabled={!canDecrypt} loading={isDecrypting} onClick={decrypt}>{t(_temp4)}</Button>;
    $[20] = canDecrypt;
    $[21] = decrypt;
    $[22] = descriptionId;
    $[23] = isDecrypting;
    $[24] = isNotAllowed;
    $[25] = t;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t8 || $[28] !== t9) {
    t10 = <div className="flex flex-col items-center gap-6 px-6 py-10 text-center">{t3}{t8}{t9}</div>;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};
export default EncryptedContent;
function _temp($) {
  return $.businessShared.encrypted.title;
}
function _temp2($_0) {
  return $_0.businessShared.encrypted.notAllowed;
}
function _temp3($_1) {
  return $_1.businessShared.encrypted.description;
}
function _temp4($_2) {
  return $_2.userData.decrypt.decryptAll;
}